import { TextConfiguration } from "../../../types";

export const calculateTextHeight = (
  text: string,
  width: number,
  font: TextConfiguration["font"]
): number => {
  const measurementDiv = document.createElement("div");
  document.body.appendChild(measurementDiv);

  measurementDiv.style.position = "absolute";
  measurementDiv.style.left = "-9999px";
  measurementDiv.style.top = "-9999px";
  measurementDiv.style.width = `${width}px`;

  measurementDiv.style.fontSize = `${font.size}px`;
  measurementDiv.style.fontFamily = font.family;
  measurementDiv.style.fontWeight = font.weight;
  measurementDiv.style.lineHeight = String(font.lineHeight);
  measurementDiv.style.fontStyle =
    font.variant === "italic" ? "italic" : "normal";

  measurementDiv.style.wordBreak = "break-word";
  measurementDiv.style.whiteSpace = "pre-line";
  measurementDiv.style.padding = "0px 20px";

  measurementDiv.innerText = text;

  const height = measurementDiv.scrollHeight;

  document.body.removeChild(measurementDiv);

  return height;
};
